import React from "react"
import styled from "@emotion/styled"
import { useStaticQuery, graphql, Link } from "gatsby"
import moment from "moment"
import SocialMedias from "./social-medias"
import SignUpForm from "components/Homepage/signupForm"
import { ThemeProvider } from "@emotion/react"
import {
    Container,
    Flex,
    useThemeUI,
    Box,
    Text,
    Link as LinkTheme,
} from "theme-ui"
import { useBreakpointIndex } from "@theme-ui/match-media"
import * as componentStyle from "assets/css/components.module.css"

const Copyright = styled.div`
    width: 100%;
    background-color: ${(props) => props.theme.colors.primary};
    padding: 1em 0;
    color: ${(props) => props.theme.colors.background};
    font-size: ${(props) => props.theme.fontSizes[2]}px;
    & a {
        text-decoration: none;
        color: ${(props) => props.theme.colors.background};
    }
`

const FooterContainer = styled.div`
    width: 100%;
    color: ${(props) => props.theme.colors.text1};
    background: #f9f9f9;
    padding: ${(props) => props.theme.space[3]}px;
    @media screen and (max-width: 1024px) {
        padding: ${(props) => props.theme.space[3]}px;
    }
`

const ColumnContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    font-weight: 100;

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        flex-direction: column;
    }
`

const Column = styled.div`
    flex: 0 0 22%;
    color: #122f53;
    line-height: 1.6em;
    font-size: 16px;

    @media screen and (max-width: ${(props) => props.theme.breakpoints[3]}) {
        flex: 0 0 20%;
    }

    @media screen and (max-width: ${(props) => props.theme.breakpoints[4]}) {
        margin-bottom: 24px;
    }

    & > .link {
        margin-bottom: 0.5em;
    }
    a.footer-link,
    a.footer-link:visited {
        color: #122f53;
        text-decoration: none;
        display: block;
        line-height: 1.5rem;
        margin-bottom: 0.5rem;
    }

    a.footer-link:hover {
        color: #273b90;
        text-decoration: none;
        font-weight: 500;
        padding-left: 0.5rem;
        transition: padding-left 0.3s linear;
        border-left: 2px solid #273b90;
    }

    a.icon-link,
    a.icon-link:visited {
        color: ${(props) => props.theme.colors.main};
    }
    a.icon-link:hover {
        color: #fff;
    }
`

const Title = styled.div`
    color: ${(props) => props.theme.colors.green};
    font-weight: 700;
    font-style: italic;
    font-size: 24px;
    font-family: Playfair Display;
    margin-bottom: 1em;

    @media screen and (max-width: ${(props) => props.theme.breakpoints[6]}) {
        font-size: 20px;
    }

    @media screen and (max-width: 576px) {
        margin-bottom: 0.5em;
    }
`

const Contact = styled.div`
    display: flex;
    margin-bottom: 0.5em;
    align-items: center;
    &span {
        padding: 0.5em 0;
    }
    &::last-child() {
        align-items: flex-start;
    }
    & .text {
        flex: 1;
        display: block;
        padding: 0;
    }
`

const Footer = (props) => {
    const context = useThemeUI()
    const { theme } = context
    const data = props.company
    const breakpoints = useBreakpointIndex()

    const menu = useStaticQuery(menuQuery)
    const submenu = menu.strapiMenu.sub_menus.sort(function (a, b) {
        return a.section - b.section
    })

    const generateSection = (section, submenu) => {
        return submenu
            .filter((x) => +x.section === section)
            .map((section, index) => {
                const title = section.displayname || section.title
                const sectionMenu = section.submenu
                    .filter((child) => child.section === "1")
                    .map((subLink) => {
                        let subMenuSection = null
                        if (subLink.childmenu && subLink.childmenu.length > 0) {
                            subMenuSection = subLink.childmenu.map(
                                (child, idx) => (
                                    <Link
                                        className="footer-link"
                                        to={child.link}
                                        key={idx}
                                    >
                                        {child.name}
                                    </Link>
                                )
                            )
                        }
                        return subMenuSection
                    })
                return (
                    <Column key={index}>
                        <Title>{title}</Title>
                        {sectionMenu}
                    </Column>
                )
            })
    }

    const section1 = generateSection(1, submenu)
    const section2 = generateSection(2, submenu)
    const section3 = generateSection(3, submenu)

    let whatsapp = null
    if (data.whatsapp) {
        whatsapp = data.whatsapp.replace(/ /g, "").replace("+", "")
    }

    return (
        <>
            <ThemeProvider theme={theme}>
                <FooterContainer>
                    <Text variant="footerText">
                        <Container>
                            <ColumnContainer>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        flexWrap: "wrap",
                                        flexDirection:
                                            breakpoints > 4 ? "row" : "column",
                                        flex: "0 0 70%",
                                    }}
                                >
                                    <Box sx={{ flex: "0 0 50%" }}>
                                        <Column>
                                            <Title>Opening Hours</Title>
                                            <Box>
                                                Monday to Friday - 9:00 AM to
                                                7:00 PM
                                                <br />
                                                Saturday - 9:00 AM to 6:00 PM
                                            </Box>
                                            <br />
                                            <Title>
                                                Subscribe to our newsletter
                                            </Title>
                                            <Box>
                                                Stay up to date every month on
                                                expert tips and insights,
                                                exclusive offers and the latest
                                                on Dynamics’ companies and
                                                services.
                                            </Box>
                                            <Box sx={{ mt: "1rem" }}>
                                                <SignUpForm />
                                            </Box>
                                        </Column>
                                    </Box>
                                    <Column>
                                        {section1}
                                        <br />
                                        {section2}
                                    </Column>
                                    <Column>{section3}</Column>
                                </Box>
                                <Box>
                                    <Column
                                        style={{
                                            flex: "0 0 30%",
                                        }}
                                    >
                                        <Title>Dynamics Wellness Centre</Title>
                                        <Contact>{data.address}</Contact>
                                        <Contact>
                                            <span
                                                className={
                                                    componentStyle.reactIcons
                                                }
                                            >
                                                Tel:
                                            </span>
                                            <span className="text">
                                                <LinkTheme
                                                    href={`tel:${data.tel}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {data.tel}
                                                </LinkTheme>
                                            </span>
                                        </Contact>
                                        <Contact>
                                            <span
                                                className={
                                                    componentStyle.reactIcons
                                                }
                                            >
                                                Whatsapp:
                                            </span>{" "}
                                            <span className="text">
                                                <LinkTheme
                                                    href={`https://wa.me/${whatsapp}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {data.whatsapp}
                                                </LinkTheme>
                                            </span>
                                        </Contact>
                                        <Contact>
                                            <span
                                                className={
                                                    componentStyle.reactIcons
                                                }
                                            >
                                                Email:
                                            </span>
                                            <span className="text">
                                                <LinkTheme
                                                    href={`mailto:${data.email}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {data.email}
                                                </LinkTheme>
                                            </span>
                                        </Contact>
                                        <Box
                                            sx={{
                                                marginTop:
                                                    `${
                                                        breakpoints > 4 ? 2 : 1
                                                    }` + "rem",
                                            }}
                                        ></Box>

                                        <SocialMedias company={data} />
                                    </Column>
                                </Box>
                            </ColumnContainer>
                        </Container>
                    </Text>
                </FooterContainer>
                <Copyright>
                    <Container
                        sx={{
                            "@media screen and (max-width: 1024px)": { px: 3 },
                        }}
                    >
                        <Flex
                            sx={{
                                justifyContent: "center",
                                "@media screen and (max-width: 576px)": {
                                    flexDirection: "column",
                                },
                            }}
                        >
                            <Text
                                variant="footerText"
                                sx={{ marginRight: "1rem" }}
                            >
                                © {moment().format("YYYY")} {data.name}.
                            </Text>
                            <Text>
                                <Link to="/terms-and-conditions">
                                    Terms &amp; Conditions
                                </Link>{" "}
                                •{" "}
                                <Link to="/privacy-policy">Privacy Policy</Link>{" "}
                                •{" "}
                                <Link to="/pdpa">
                                    Personal Data Protection Act
                                </Link>
                            </Text>
                        </Flex>
                    </Container>
                </Copyright>
            </ThemeProvider>
        </>
    )
}

export default Footer

const menuQuery = graphql`
    {
        strapiMenu(
            menu_type: { eq: "footer" }
            company: { shortname: { eq: "WNS" } }
            sub_menus: {}
        ) {
            sub_menus {
                menu
                name
                displayname
                section
                submenu {
                    id
                    link
                    name
                    section
                    childmenu {
                        id
                        link
                        name
                    }
                }
                url
            }
            name
        }
    }
`
